import Swal from "sweetalert2";
import { CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { failureAlert } from "../../CommonUtils/SweetAlerts.jsx";

// export const useRusaFormSubmit = (apiUrl) => {
//     const submitForm = (payload, onSuccess) => {
//         Swal.fire({
//             text: "Are you sure you want to submit?",
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonText: "Yes, submit it!",
//             cancelButtonText: "No, cancel!",
//             backdrop: false,
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 CommonAxiosPost(apiUrl, payload)
//                     .then((res) => {
//                         if (res?.data?.scode === "01") {
//                             Swal.fire(res?.data?.sdesc, "", "success").then((r) => {
//                                 // if (r.isConfirmed || r.isDismissed) {
//                                 //     if (onSuccess) onSuccess();
//                                 //     else window.location.reload();
//                                 // }
//                             });
//                         } else {
//                             failureAlert(res?.data?.sdesc || "Failed to Submit")
//                         }
//                     })

//             }
//         });
//     };

//     return { submitForm };
// };


export const useRusaFormSubmit = () => {

    const submitForm = (payload, onSuccess, apiUrl, confirmText) => {

        Swal.fire({
            text: confirmText,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                CommonAxiosPost(apiUrl, payload)
                    .then((res) => {
                        if (res?.data?.scode === "01") {
                            Swal.fire(res?.data?.sdesc, "", "success").then(() => {
                                onSuccess && onSuccess();
                            });
                        } else {
                            failureAlert(res?.data?.sdesc || "Failed");
                        }
                    })
                    .catch(() => failureAlert("API Error"));
            }
        });
    };

    return { submitForm };
};
